module.exports = __webpack_public_path__ + "static/marabu-450931fd7b293587cef9ec919749bbb2.png";